import { render, staticRenderFns } from "./JettonTabHolders.vue?vue&type=template&id=0e086474"
import script from "./JettonTabHolders.vue?vue&type=script&lang=js"
export * from "./JettonTabHolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports